<div class="ldg" [style.--dvm-ldg-label-bg]="data.accentColor || null">
  <div
    class="ldg-row"
    *ngFor="let field of fields; trackBy: trackByKey"
    [style.height]="rowHeight"
  >
    <div
      class="ldg-label"
      [style.width]="labelWidth"
      [style.flex-basis]="labelWidth"
      [title]="field.config.label"
    >
      {{ field.config.label }}<span class="ldg-required" *ngIf="field.config.required">*</span>
    </div>
    <div class="ldg-value ldg-value--embedded">
      <ng-container [ngSwitch]="field.kind">
        <!-- Multi-select: reuse the shared dropdown so search/select-all and the
             array payload stay identical to the plain `dropdown` widget. -->
        <app-global-dropdown
          *ngSwitchCase="'multi'"
          class="ldg-embedded"
          [data]="field.config"
          [options]="field.options"
          (filterChanged)="onMultiValueChange(field, $event)"
        ></app-global-dropdown>

        <!-- Date: reuse the multi-date picker widget unchanged. -->
        <app-date-range-filter
          *ngSwitchCase="'date'"
          class="ldg-embedded"
          [data]="field.config"
        ></app-date-range-filter>

        <!-- Local single-select: same ng-select skin as multi-select, without
             changing the shared global-dropdown implementation. -->
        <ng-container *ngSwitchDefault>
          <ng-select
            class="ldg-embedded ldg-single-select"
            [items]="field.options"
            [searchable]="false"
            [closeOnSelect]="true"
            [hideSelected]="false"
            [clearable]="field.config.disabled !== true"
            [disabled]="field.config.disabled === true"
            [appendTo]="field.config.appendTo || 'body'"
            [placeholder]="field.config.disabled
              ? (field.config.disabledPlaceholder || 'Select a value first')
              : (field.config.placeholder || 'All')"
            [ngModel]="field.value"
            (ngModelChange)="onValueChange(field, $event)"
          >
            <ng-template ng-option-tmp let-item="item">
              <div
                [title]="item"
                (click)="onSingleOptionClick(field, item, $event)"
              >{{ item }}</div>
            </ng-template>
          </ng-select>
        </ng-container>
      </ng-container>
      <span class="ldg-caret" aria-hidden="true"></span>
    </div>
  </div>
</div>
